import { types } from 'mobx-state-tree';

const __View = types
	.model({
		isLoading: types.map(types.boolean),
		hasErrors: types.map(types.string),
	})
	.named('View')
	.actions((self) => ({
		setIsLoading(what, value = true) {
			self.isLoading.set(what, value);
		},
		setHasErrors(what, value = '') {
			self.hasErrors.set(what, value);
		},
		removeError(what) {
			self.hasErrors.delete(what);
		},
		clearAllErrors() {
			self.hasErrors.clear();
		},
		clearAllLoading() {
			self.isLoading.clear();
		},
	}));

export const View = types.snapshotProcessor(__View, {
	preProcessor(snapshot) {
		return {
			...snapshot,
			isLoading: {},
			hasErrors: {},
		};
	},
});
